import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'pixl-main-learn-item',
  imports: [],
  templateUrl: './main-learn-item.component.html',
  styleUrl: './main-learn-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainLearnItemComponent {

}
